export default __webpack_public_path__ + "static/media/mailbox.6cd801da.svg";